import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDolJg_NGIzFo5FqCAK26Wpn2nlzfPEib8",
  authDomain: "chat.kimczym.pl",
  projectId: "triochat-55035",
  storageBucket: "triochat-55035.firebasestorage.app",
  messagingSenderId: "456110509056",
  appId: "1:456110509056:web:cc5d530667f9b48ab29ce5",
  measurementId: "G-HG0QEEVQCN"
};

let app: any;
let auth: any;
let db: any;
let storage: any;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  setPersistence(auth, browserLocalPersistence);
  db = getFirestore(app);
  storage = getStorage(app);
} catch (e) {
  console.error("Firebase Initialization Error", e);
}

export { app, auth, db, storage };
export const isConfigured = !!app;
